import { bootstrap } from 'angular2/platform/browser';
import { provide } from 'angular2/core';
import { FORM_PROVIDERS } from 'angular2/common';
import { ROUTER_PROVIDERS, ROUTER_DIRECTIVES } from 'angular2/router';
import { Http, HTTP_PROVIDERS } from 'angular2/http';
import { AuthConfig, AuthHttp } from 'angular2-jwt';

import { UserService } from './user/user.service';
import { EventService } from './event/event.service';
import { CompanyService } from './company/company.service';
import { AttendeeService } from './attendee/attendee.service';
import { ApiClient } from './api/api-client.service';
import { Resource } from './api/resource.service';
import { Sidebar } from './layout/sidebar/sidebar';
import { Header } from './layout/header/header';
import { AlertService } from './alert/alert.service';
import { Alert } from './alert/alert';
import { PaginationService } from './pagination/pagination-service';
import { SortService } from './sort/sort-service';

import { API_HOST } from './config/config';
import { App } from './app/app';

bootstrap(
  App,
  [
    FORM_PROVIDERS,
    ROUTER_PROVIDERS,
    ROUTER_DIRECTIVES,
    HTTP_PROVIDERS,
    Sidebar,
    Header,
    Alert,
    AlertService,
    PaginationService,
    SortService,
    provide(AuthHttp, {
      useFactory: (http) => {
        return new AuthHttp(new AuthConfig({
          tokenName: 'jwt'
        }), http);
      },
      deps: [Http]
    }),
    provide(ApiClient, {
      useFactory: (http, authHttp) => {
        return new ApiClient(http, authHttp, API_HOST);
      },
      deps: [Http, AuthHttp]
    }),
    provide(UserService, {
      useFactory: (apiClient) => {
        return new UserService(new Resource(apiClient, '/users'));
      },
      deps: [ApiClient]
    }),
    provide(EventService, {
      useFactory: (apiClient) => {
        return new EventService(new Resource(apiClient, '/events'));
      },
      deps: [ApiClient]
    }),
    provide(CompanyService, {
      useFactory: (apiClient) => {
        return new CompanyService(new Resource(apiClient, '/companies'));
      },
      deps: [ApiClient]
    }),
    provide(AttendeeService, {
      useFactory: (apiClient) => {
        return new AttendeeService(new Resource(apiClient, '/attendees'));
      },
      deps: [ApiClient]
    })
  ]
);



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/index.ts
 **/